import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import styles from "./Search.module.css";

export default function FreeSolo(props) {
  const neighborhoods = [];
  props.data.map((d) => {
    if (!neighborhoods.includes(d.communityarea)) {
      neighborhoods.push(d.communityarea);
    }
  });
  return (
    <div className={styles.Search} style={{ width: "100%", maxWidth: 500 }}>
      <Autocomplete
        id="free-solo-demo"
        options={neighborhoods.sort((a, b) => a > b).map((option) => option)}
        onChange={(event, newValue) => {
          props.selectNeighborhood(newValue);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Search Neighborhoods"
            margin="normal"
            variant="outlined"
          />
        )}
      />
    </div>
  );
}
